import React from 'react';
import { BrandButton as Button, SearchableSelect } from "@/components";

/**
 * Card component for duplicating surveys
 * Creates a NEW survey with a new ID by copying an existing one
 */
export default function DuplicateSurveyCard({
  publishedSurveys,
  selectedSurveyId,
  onSurveyChange,
  onDuplicateClick,
  loading
}) {
  return (
    <div className="col-md-6 mb-4">
      <div className="card h-100">
        <div className="card-body">
          <h4 className="card-title" style={{ color: "#F16D09" }}>Duplicate Survey</h4>
          <p className="card-text">
            Create a NEW survey by copying an existing one. Perfect for monthly surveys where you need separate data collection every month (or any other time period).
          </p>
          <div className="alert alert-sm alert-info" style={{ fontSize: '0.9rem' }}>
            Example: Copy "January 2026" to create "February 2026" with a new survey ID.
          </div>
          
          <div className="mb-3">
            <label className="form-label">Select Survey to Duplicate and the publish dialogue will open:</label>
            <SearchableSelect
              options={[...publishedSurveys].sort((a, b) => a.title.localeCompare(b.title))}
              value={selectedSurveyId || ''}
              onChange={(surveyId) => onSurveyChange(surveyId || "")}
              placeholder="Search or select..."
              getLabel={(survey) => survey.title}
              getValue={(survey) => survey.id}
              disabled={loading}
            />
          </div>
          
          <Button 
            onClick={onDuplicateClick}
            disabled={!selectedSurveyId || loading}
            style={{ width: "100%" }}
          >
            Duplicate & Publish
          </Button>
        </div>
      </div>
    </div>
  );
}
